import { CIcon } from '~/icons/types'

export const ciRealEstate: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.5 20.692H21v-9h.982a1 1 0 0 0 .6-1.8L21 8.719V4.692a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.07l-4.4-3.254a1 1 0 0 0-1.187 0L1.42 9.888a1 1 0 0 0 .6 1.8H3v9H.5a.5.5 0 1 0 0 1h23a.5.5 0 0 0 0-1v.004Zm-5.5-16h2V7.98l-2-1.478v-1.81Zm-15.983 6L12 3.312l5.134 3.79a.5.5 0 0 0 .152.113l2.854 2.112c.024.022.05.04.078.057l1.764 1.3-19.965.008Zm7.983 10H7v-6h3v6Zm10 0h-9v-6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6H4v-9h16v9Z'
    },
    {
      d:
        'M14 18.691h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1Zm0-4h4v3h-4v-3Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'real-estate',
  type: 'thin'
}
